import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUp, MessageCircle, Eye } from "lucide-react";

const TYPE_BADGE = {
  community_starter: { label: "Community Starter", cls: "bg-teal/10 text-teal" },
  editorial: { label: "Editorial", cls: "bg-plum/10 text-plum" },
  expert: { label: "Expert", cls: "bg-rose/40 text-plum" },
  member: { label: "Member", cls: "bg-rose-soft text-mutedplum" },
};

export default function ThreadCard({ thread, index = 0 }) {
  const badge = TYPE_BADGE[thread.author_type] || TYPE_BADGE.member;
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.3) }}
    >
      <Link
        to={`/community/${thread.category_slug}/${thread.slug}`}
        data-testid={`thread-card-${thread.slug}`}
        className="group block bg-white rounded-3xl shadow-card border border-rose/30 p-6 hover:shadow-soft hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
      >
        <div className="flex items-center gap-2 mb-3">
          <span className={`text-xs font-semibold px-3 py-1 rounded-full ${badge.cls}`}>{badge.label}</span>
        </div>
        <h3 className="font-display text-xl text-plum leading-snug group-hover:text-teal transition-colors">
          {thread.title}
        </h3>
        <p className="mt-2 text-[15px] text-mutedplum line-clamp-2">{thread.body}</p>
        <div className="mt-4 flex items-center gap-5 text-sm text-mutedplum">
          <span className="inline-flex items-center gap-1.5"><ArrowUp className="h-4 w-4" />{thread.upvotes}</span>
          <span className="inline-flex items-center gap-1.5"><MessageCircle className="h-4 w-4" />{thread.reply_count}</span>
          <span className="inline-flex items-center gap-1.5"><Eye className="h-4 w-4" />{thread.view_count}</span>
        </div>
      </Link>
    </motion.div>
  );
}
